<template>
	<section role="main" class="content-body">
		<header class="page-header">
			<h2>公告訊息</h2>
			<div class="right-wrapper">
				<ol class="breadcrumbs">
					<li>
						<router-link to="/">
							<i class="fa fa-home"></i>
						</router-link>
					</li>
					<li>公告訊息</li>
				</ol>
			</div>
		</header>
		<div class="main" style="min-height:768px;" >
			<section class="panel">
				<header class="panel-heading" v-if="!isEdit">
					<h2 class="panel-title">{{news.newsTypeStr ? '['+news.newsTypeStr+']' : ''}}{{news.title}}</h2>
				</header>
				<div class="panel-body ">
					<p class="text-right" v-if="isAdmin('bulletin') && showEditBtn"><button type="button" class="btn btn-danger m-xs" id="" @click="isEdit = true">編輯</button></p>
					<div  v-if="isEdit">
						<div class="row fom-group">
							<div class="col-md-offset-1 col-md-10 fom-group">
								<label class="col-xs-2">公告標題:</label>
								<span class="col-xs-10">
									<input class="form-control" v-model="news.title"/>
								</span>
							</div>
						</div>
						<br/>
						<div class="row fom-group">
							<div class="col-md-offset-1  col-md-5">
								<label class="col-xs-4">公告日期(起):</label>
								<span class="col-xs-8">
									<datepicker :format="customFormatter" :language="zh" v-model="news.newsBeginDate" :disabled-dates="beginState.disabledDates" input-class="form-control" placeholder="開始日期" :style="{width:'auto', display:'inline-block'}" />
								</span>
							</div>
							<div class="col-md-5">
								<label class="col-xs-4">公告日期(迄):</label>
								<span class="col-xs-8">
									<datepicker :format="customFormatter" :language="zh" v-model="news.newsEndDate" :disabled-dates="beginState.disabledDates" input-class="form-control" placeholder="開始日期" :style="{width:'auto', display:'inline-block'}" />
								</span>
							</div>
						</div>
						<br/>
						<div class="col-md-offset-1  col-md-10">
							<ckeditor v-model="news.newsContent" :config="editorConfig" ></ckeditor>
						</div>
						<br/>
					</div>
					<div v-else>
						<div class="row fom-group">
							<div class="col-md-offset-1  col-md-5">
								<label class="col-xs-4">公告日期(起):</label>
								<span class="col-xs-8">
									{{news.newsBeginDateCht}}
								</span>
							</div>
							<div class="col-md-5">
								<label class="col-xs-4">公告日期(迄):</label>
								<span class="col-xs-8">
									{{news.newsEndDateCht}}
								</span>
							</div>
						</div>
						<br/>
						<div class="row fom-group">
							<div class="col-md-offset-1  col-md-5">
								<label class="col-xs-4">發佈人:</label>
								<span class="col-xs-8">
									[{{news.publishUnit}}]&emsp;{{news.publishUser}}
								</span>
							</div>
							<div class="col-md-5">
								<label class="col-xs-4">發佈日期:</label>
								<span class="col-xs-8">
									{{news.crDateCht}}
								</span>
							</div>
						</div>
						<hr/>
						<div class="row fom-group">
							<div class="col-md-offset-1  col-md-10" v-html="news.newsContent"></div>
						</div>
					</div>
					<br/>
					<div class="row form-group">
						<div class="col-md-offset-1 col-md-10 form-group" v-if="isEdit">
							<label class="col-xs-6 col-md-3">附件上傳：</label>
							<label class="col-xs-6 col-md-3" for="introductFile">
								<div style="display:none;">
									<input type="file" id="introductFile" style="width: 100%" accept=".pdf,image/*" ref="introductFile" @change="headleFile($event)" multiple="multiple"/>
								</div>
								<a class="btn btn-default">請選擇檔案</a>
							</label>
						</div>
						<div class="col-md-offset-1  col-md-10 form-group">
							<p v-for="(item, index) in this.news.fileList" :key="index">
								<span v-if="item.filePath">
									<a class="btn btn-link" @click="downloadFile(item)" style="color: #337ab7" target="_blank">{{item.fileName}}</a>
									<a class="btn btn-link" v-if="isEdit" @click="deleteFile(item.id)" style="color: #FF0000"><i class="glyphicon glyphicon-trash"></i></a>
								</span>
								<span v-if="item.preview || item.previewPdf">
									<a v-if="item.preview" :href="item.preview" target="_blank">
										<img class="img-fluid" :src="item.preview" alt="" style="width:200px;"/>
									</a>
									<a v-if="item.previewPdf" href="javascript:;" @click="downloadPreview(item.previewPdf)" >
										{{item.previewPdf.name}}
									</a>
								</span>
							</p>
						</div>
					</div>
					<div class="row form-group" v-if="isEdit">
						<div class="col-md-offset-4 col-md-2">
							<a href="javascript:;" class="btn s_btn_b btn-block" @click="clickPrevious()">返回</a>
						</div>
						<div class=" col-md-2">
							<a @click="saveEvent" class="btn btn-primary btn-block">儲存</a>
						</div>
					</div>
					<div class="row form-group" v-else>
						<div class="col-md-offset-5 col-md-2">
							<a href="javascript:;" class="btn s_btn_b btn-block" @click="clickPrevious()">返回</a>
						</div>
					</div>
				</div>

			</section>
		</div>
	</section>

</template>
<script>
import CKEditor from "@/ckeditor4";
export default {
	components: {
		ckeditor: CKEditor.component
	},
	data(){
		return {
			storeData:{},
			isEdit:false,
			showEditBtn:false,
			news:{
				id:"",
				title:"",
				newsType:"",
				newsTypeStr:"",

				isKeepReader:"",
				newsContent:"",
				fileList:[]
			},
			newsTypeList:[],
			uploadFiles:[],
			editorConfig: {
				extraPlugins: ["colorbutton", "uploadimage"],
				filebrowserImageUploadUrl:"/api/Common/uploadEditorImage",
				height:500,
				toolbar: [
					["Source"],
					["Cut", "Copy", "Paste", "PasteText", "PasteFromWord"],
					["Undo", "Redo"],
					["RemoveFormat"],
					["NumberedList", "BulletedList"],
					["Outdent", "Indent"],
					["Blockquote"],
					["Link", "Unlink", "Anchor"],
					["Image", "Table", "HorizontalRule"],
					["SpecialChar"],
					"/",
					["Styles", "Format"],
					["Bold", "Italic", "Strike"],
					["TextColor", "BGColor"],
					["Maximize"],
					["About"]
				]
			},
			beginState:{
				disabledDates:{
					to: this.toDate()
				}
			},
		}
	},
	mounted(){
		if (this.getStore(this.$route.name) != null) {
			this.storeData = JSON.parse(this.getStore(this.$route.name));
			this.isEdit = this.storeData.isEdit == "Y";
			this.showEditBtn = this.storeData.isEdit != "Y";
			if("id" in this.storeData){
				this.news.id = this.storeData.id;
				this.init();
			}
		}
	},
	methods:{
		init(){
			const api = "/api/News/newsDetail/"+this.news.id;
			this.$axios.post(api).then(resp =>{
				this.news = resp.data.data;
				this.news.newsContent = this.news.newsContent = this.htmlDecode(this.news.newsContent);
			});
		},
		clickPrevious() {
			this.$router.go(-1);
			this.$router.replace("",this.storeData);
		},
		downloadFile(fileItem){
			const api = "/api/Common/downloadNewsFile/";
			this.$axios.post(api, JSON.stringify({model:fileItem.filePath}), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", fileItem.fileName);
				document.body.appendChild(link);
				link.click();
			});
		},
		headleFile(event) {
			let self = this
			if(event.target.files.length > 0){
				let fileList = event.target.files;
				for(let i=0; i < fileList.length; i++){
					let item = fileList[i];
					this.uploadFiles.push(item);
					let fileValue ={
						fileName:item.name,
						filePath:"",
						preview:null,
						previewPdf:null
					};
					if(item.name.slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2) == "pdf"){
						let reader = new FileReader();
						reader.readAsDataURL(item);
						fileValue.previewPdf = item;
					}else{
						this.imgPreview(item).then(result =>{
							fileValue.preview = result;
						})
					}
					this.news.fileList.push(fileValue);
				}
			}
		},
		downloadPreview(fileObj){
			console.log(fileObj);
			const url = window.URL.createObjectURL(new Blob([fileObj.result]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", fileObj.name);
			document.body.appendChild(link);
			link.click();
		},
		saveEvent(){
			this.news.isKeepReader = "N";
			this.news.newsType = "OPEN";
			let formData = new FormData();
			for(let k in this.news){
				let v = this.news[k];
				if(k == "newsContent"){
					v = this.htmlEncode(v);
				}
				if(k == "newsBeginDate" || k == "newsEndDate"){
					v = this.customFormatter(v);
				}

				if(k == "fileList"){
					continue;
				}
				formData.append("news."+k, v);
			}
			for(let i=0; i< this.uploadFiles.length;i++){
				formData.append("newsFileList", this.uploadFiles[i]);
			}
			let api = "/api/News/editNews";
			this.$axios.post(api, formData).then(resp => {
				bootbox.alert(resp.data.msg);
				if(resp.data.status == "success"){
          this.news.id = resp.data.data.id;
					this.init();
					this.isEdit = false;
				}
			});
		},
		deleteFile(id){
			let api = "/api/News/deleteFile/"+id;
			this.$axios.delete(api).then(resp => {
				if(resp.data.status == "success"){
					this.news.fileList = this.news.fileList.filter(item =>{
						return item.id != id;
					});
					this.isEdit = false;
				}
			});
		},
		toDate(){
			let date = this.nowDate();
			date.setDate(date.getDate() -1);
			return date;
		}
	},
	beforeRouteLeave(to, from, next) {
		this.removeStore(this.$route.name);
		next();
	}
}
</script>
